import React, { useEffect, useState } from "react";
import api from "../../api/axios";
import DealerCreateModal from "./DealerCreateModal";
import DealerEditModal from "./DealerEditModal";

const DealersSection = () => {
  const [dealers, setDealers] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [editDealer, setEditDealer] = useState(null);

  const fetchDealers = async () => {
    const res = await api.get("companyblog/admin/dealers/");
    setDealers(res.data);
  };

  useEffect(() => {
    fetchDealers();
  }, []);

  const handleDelete = async (id) => {
    await api.delete(`companyblog/admin/dealers/${id}/`);
    fetchDealers();
  };

  return (
    <>
    <div className="card">
      <div className="card-header d-flex justify-content-between">
        <h4>All Dealers</h4>
        <button className="btn btn-success" onClick={() => setShowCreate(true)}>
          + New Dealer
        </button>
      </div>

      <div className="card-body">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {dealers.map((dealer, index) => (
              <tr key={dealer.id}>
                <td>{index + 1}</td>
                <td>{dealer.dealers_name}</td>
                <td>{dealer.email}</td>
                <td>{dealer.phone_no}</td>
                <td>
                  <button
                    className="btn btn-primary btn-sm me-2"
                    onClick={() => setEditDealer(dealer)}
                  >
                    Edit
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(dealer.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
      {showCreate && (
        <DealerCreateModal
          onClose={() => setShowCreate(false)}
          onSaved={fetchDealers}
        />
      )}

      {editDealer && (
        <DealerEditModal
          dealer={editDealer}
          onClose={() => setEditDealer(null)}
          onSaved={fetchDealers}
        />
      )}
       </>
    
   
  );
};

export default DealersSection;
